module.exports = __webpack_public_path__ + "img/dialog-ikona.e15dd36c.png";